export default customElements.define('w-field-criteria-box', class FieldTextbox extends wealthify.componentBases.FieldText {
    constructor () {
        // update field-text to expect instances to append
        const config = {defaultSlotContents: {button: '<w-widget-button class="u-display__none" type="uncircled" icon="eye" iconactivated="eye-struck" label="Show password" data-button data-slot="button"></w-widget-button>'}};

        super(config);
        this.addEventListener(this.events.ValueChange.name, this.#validateCriteria);

        this.onConnectedCallback = () => {
            this.#updateCriteriaVisibility();
            this.dom.button.onclickprop = this.#togglePasswordVisibility.bind(this);
            this.addEventListener(this.events.DisabledToggled.name, this.#updateCriteriaVisibility);
            this.addEventListener(this.events.ReadOnlyToggled.name, this.#updateCriteriaVisibility);
        };
    }

    // static properties
    static styleSelector = 'c-field-criteria-box';

    static get requiredProperties() {
        return [ 'pattern', 'description'];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('criteria', {
                type: wealthify.propTypes.Array(),
                validators: [
                    wealthify.propValidators.ArrayObjectContainsKeys(this.requiredProperties)
                ]
            }),
            new wealthify.Prop('is-private', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('context-label', {default: 'input'}),
        ];
    }

    // instance properties
    get propCallbacks() {
        return {
            criteria: () => this.#initialiseCriteria(),
            isPrivate: () => {
                const classListAction = this.isPrivate ? 'remove' : 'add';

                if(this.isPrivate){
                    this.isObscured = true;
                    this.#setPasswordVisibility();
                    this.addEventListener('keydown', this._restrictAngleBrackets.bind(this));
                    this.addEventListener('paste', this._restrictAngleBrackets.bind(this));
                }else{
                    this.forceButtonSlotHidden = true;
                }

                this.dom.button.classList[classListAction]('u-display__none');
            },
            contextLabel: () => {
                if(!this.isCriteriaInitialised){
                    return;
                }

                this.#updateContextLabelContent();
            },
        };
    }

    get isCriteriaInitialised(){
        return this.items !== undefined;
    }

    get invalidErrorMessage () {
        return `Please enter a valid ${this.contextLabel}`;
    }

    get contextLabelText () {
        return `Your ${this.contextLabel} must contain:`;
    }

    isObscured = true;

    #initialiseCriteria(){
        this.items = [];

        const containerDiv = document.createElement('div');
        const contextLabelElement = document.createElement('p');
        const criteriaList = document.createElement('ul');

        containerDiv.classList.add(`${this.styleSelector}__container`);

        containerDiv.dataset.criteriaContainer = '';
        contextLabelElement.dataset.contextLabel = '';
        contextLabelElement.classList.add('u-text__weight--bold');
        this.dom.contextLabel = contextLabelElement;
        this.#updateContextLabelContent();

        // storing component context for use in getter as 'this' will be
        // the object in the context of a getter.
        const componentContext = this;

        // Only iterate over criteria array if has already been initialised.
        if(this.isCriteriaInitialised) {
            this.criteria.forEach((criteria, index) => {

                const criteriaListItem =  document.createElement('li');
                const criteriaLabel = document.createElement('span');

                this.items[index] = {
                    get valid () {
                        return this.pattern.test(componentContext.value);
                    },
                    updateUI: () => {
                        this.#updateSingleCriteriaUI(this.items[index]);
                    },
                    pattern: criteria.pattern,
                    elements: {
                        criteriaListItem,
                        criteriaLabel
                    }
                };

                criteriaList.classList.add(`${this.styleSelector}__list`);
                criteriaListItem.classList.add(`${this.styleSelector}__list-item`);
                criteriaListItem.setAttribute('aria-live', 'polite');
                criteriaListItem.setAttribute('aria-atomic', true);
                criteriaLabel.classList.add('u-display__hidden');

                criteriaListItem.appendChild(criteriaLabel);
                criteriaListItem.insertAdjacentHTML('beforeend', criteria.description);
                criteriaList.appendChild(criteriaListItem);

                this.items[index].updateUI();
            });
        }

        containerDiv.appendChild(contextLabelElement);
        containerDiv.appendChild(criteriaList);
        this.dom.root.appendChild(containerDiv);
    }

    #updateContextLabelContent(){
        this.dom.contextLabel.textContent = this.contextLabelText;
    }

    #updateSingleCriteriaUI (criteriaItem) {
        const validClassListAction = criteriaItem.valid ? 'add' : 'remove';
        const invalidClassListAction = criteriaItem.valid ? 'remove' : 'add';

        criteriaItem.elements.criteriaLabel.textContent = criteriaItem.valid ? 'Passed:' : 'Not passed:';
        criteriaItem.elements.criteriaListItem.classList[validClassListAction](`${this.styleSelector}__list-item--valid`);
        criteriaItem.elements.criteriaListItem.classList[invalidClassListAction](`${this.styleSelector}__list-item--invalid`);
    }

    #validateCriteria() {
        if (!this.isCriteriaInitialised) {
            return;
        }

        this.items.forEach((item) => item.updateUI());

        const isComponentInvalid = this.items.filter((item) => !item.valid).length;

        this.messageCustom = isComponentInvalid ? this.invalidErrorMessage : '';
    }

    _restrictAngleBrackets (event) {
        const containsAngleBrackets = this._checkEventContainsAngleBrackets(event);

        if (containsAngleBrackets) {
            event.preventDefault();
        }
    }

    _checkEventContainsAngleBrackets (event) {
        const data = event.clipboardData ? event.clipboardData.getData('text/plain') : event.key;
        const regexAngleBrackets = /[<>]+/;

        return new RegExp(regexAngleBrackets).test(data);
    }

    #togglePasswordVisibility() {
        this.isObscured = !this.isObscured;
        this.dom.button.activated = !this.isObscured;
        this.dom.button.label = this.isObscured ? 'Show password' : 'Hide password';
        this.#setPasswordVisibility();
    }

    #setPasswordVisibility(){
        this.dom.fieldinput.type = this.isObscured ? 'password' : 'text';
    }

    #updateCriteriaVisibility() {
        if (!this.isCriteriaInitialised) {
            return;
        }

        const classListAction = this.readonlyprop || this.disabledprop ? 'add' : 'remove';

        this.dom.criteriaContainer.classList[classListAction]('u-display__none');
    }
});